/**
 * Checks if 2 strings are equals ignoring case.
 * @param str1 the first string
 * @param str2 the second string
 * @returns {boolean} true if the 2 strings are equals ignoring case
 */
export function isEqualsIgnoringCase(str1, str2) {
  return str1?.toUpperCase() === str2?.toUpperCase();
}

/**
 * Checks if one string contains another string ignoring case.
 * @param str1 the first string
 * @param str2 the second string
 * @returns {boolean} true if the first string contains the second string ignoring case
 */
export function containsIgnoringCase(str1, str2) {
  return str1?.toUpperCase().indexOf(str2?.toUpperCase()) !== -1;
}

/**
 * Converts a string to boolean. (true, yes, 1 -> TRUE / false, no, 0 -> FALSE)
 * @param value the value
 * @param defaultValue the default value when value is undefined
 * @returns {boolean|any} the boolean value from string value
 */
export function toBoolean(value, defaultValue = false) {
  if (value == null) {
    return defaultValue;
  }
  if (typeof value === 'string') {
    switch (value?.toLowerCase()?.trim()) {
      case 'true':
      case 'yes':
      case '1':
        return true;

      case 'false':
      case 'no':
      case '0':
      case null:
      case undefined:
        return false;

      default:
        return JSON.parse(value);
    }
  }
  return value;
}

/**
 * Checks if string starts with any prefixes.
 * @param elem the string to check
 * @param prefixes the array of prefixes
 * @returns {boolean} true if the string starts with any prefixes
 */
export function startsWith(elem, prefixes) {
  return prefixes?.some((prefix) => elem?.startsWith(prefix));
}

/**
 * Checks if a string is a number.
 * @param str the string to check
 * @returns {boolean} true if the string is a number
 */
export function isNumber(str) {
  if (str.trim() === '') {
    return false;
  }

  return !Number.isNaN(Number(str));
}

/**
 * Finds the substring before a separator (first).
 * @param str the string
 * @param separator the separator
 * @returns {*} the substring
 */
export function substringBefore(str, separator) {
  return str.split(separator)[0];
}
